<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getCompanies"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons>
        <b-button
          class="ml-2"
          :to="{ name: 'companies-create' }"
          variant="primary"
          v-if="user.is_admin == 1"
        >
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
      </template>

      <template v-slot:headings>
        <div class="col-md-1"></div>
        <div class="col-md-8">Name</div>
        <div class="col-md-3 text-left text-md-right">Action</div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-md-1 my-auto">
          <v-lazy-image
            v-if="slotProps.item.logo"
            :src="slotProps.item.logo"
            class="img-fluid maxHeight32"
          />
        </div>

        <div class="col-md-8 my-auto">
          <p class="m-0 font-weight-bold">{{ slotProps.item.name }}</p>
        </div>

        <div class="col-md-3 my-auto text-left text-md-right pt-3 pt-md-0">
          <router-link
            v-b-tooltip.hover
            title="view"
            :to="{ name: 'companies-show', params: { id: slotProps.item.id } }"
            class="text-info table-action-icon"
          >
            <i class="lni lni-search-alt"></i>
          </router-link>

          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{ name: 'companies-edit', params: { id: slotProps.item.id } }"
            class="text-primary table-action-icon"
          >
            <i class="lni lni-pencil"></i>
          </router-link>

          <span
            v-b-tooltip.hover
            style="cursor: pointer"
            title="Delete"
            @click="confirmDelete(slotProps.item.id)"
            class="text-danger table-action-icon"
          >
            <i class="lni lni-trash"></i>
          </span>
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
import companyRepo from "@/api/repos/companyRepo";
import dataTable from "@/components/common/DataTable";

export default {
  components: {
    dataTable: dataTable,
  },

  data() {
    return {      
      items: [],
      isLoad:false,
      sort: { column: "name", label: "Name Asc", order: "asc" },
      sortOptions: [
        { column: "name", label: "Name Asc", order: "asc" },
        { column: "name", label: "Name Desc", order: "desc" },
      ],      
      filter: null,
      filterOptions: [
        { column: "is_vatable", value: "1", label: "Vatable" }
      ],
      page: 1,
      rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
    };
  },
  mounted() {
    this.getCompanies({
      sort:this.sort,
      filters:null,
      page: this.page,
      rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
      search: "",
    });
  },
  methods: {
    async deleteCompany(id) {
      this.isLoad = true;
      try {
        await companyRepo.delete(id);
        this.items = this.items.filter((item) => item.id !== id);
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the company.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => (confirm ? this.deleteCompany(id) : false))
        .catch((error) => console.log(error));
    },
    async getCompanies(e) {
      
      this.isLoad = true;

      try {
        let { data } = await companyRepo.companies(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters!=null?e.filters:null
        );

        this.items = data.companies.data;
        this.totalRows = data.companies.total;
        this.page = data.companies.current_page;
        this.fromRow = data.companies.from;
        this.toRow = data.companies.to;
        this.lastPage = data.companies.last_page;

      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },
    
  },  

  computed: {
    user() {
      return this.$store.state.user.user;
    },
  },
};
</script>
